import { IOptions } from "../components/FormFields/CustomSelect";
import axios from "../utils/axios";

/**
 * Method to fetch roles.
 */
const fetchRoles = async () => {
    try {
        // Backend exposes roles at /api/v1/role and returns { rolesList: [{ _id, role }] }
        const response = await axios.get('/api/v1/role');
        const roles: { _id: string; role: string }[] = response.data?.rolesList || [];

        const options: IOptions[] = roles.map(({ _id, role }) => ({
            label: role.charAt(0).toUpperCase() + role.slice(1),
            value: _id,
        }));

        return options;

    } catch (error: any) {
        // Empty catch block.
    }
}

const RoleService = {
    fetchRoles,
};

export default RoleService;
